<template>
    <div v-if="show" class="preloader">
        <div class="preloader__circle"></div>
    </div>
</template>
<script>
    export default {
        name: 'Preloader',
        props: {
            show: {
                type: Boolean,
                default() {
                    return false;
                },
            },
        },
    };
</script>
<style lang="scss" scoped>
    $b: '.preloader';

    @mixin spinner($size, $width, $color) {
        content: '';
        display: block;
        width: $size;
        height: $size;
        border-radius: 50%;
        position: absolute;
        pointer-events: none;
        animation: spin 0.7s linear infinite;
        top: 50%;
        left: 50%;
        margin: (-($size / 2)) 0 0 (-($size / 2));
        border: $width solid transparent;
        border-bottom-color: $color;
        border-left-color: $color;
        z-index: 1;
    }

    #{$b} {
        $preloader-inner: #00b2ac;
        $preloader-background: #fff;
        $preloader-transition: 1s;
        $preloader-easing: ease;

        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        width: 100%;
        height: 100%;
        background: $preloader-background;
        opacity: 1;
        visibility: visible;
        transition: opacity $preloader-transition $preloader-easing, visibility $preloader-transition $preloader-easing;

        &__circle {
            @include spinner(26px, 2px, $preloader-inner);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
</style>
